import classNames from "classnames";
import { CgSpinner } from "react-icons/cg";
import FlexCentered from "../Containers/FlexCentered";

function Button({
  primary,
  secondary,
  danger,
  outline,
  rounded,
  loading,
  disabled,
  className,
  children,
  ...props
}) {
  const classes = classNames(
    "border tracking-wide outline-none focus:ring-hgGreen-200 active:ring-hgGreen-200 hover:bg-opacity-80 ",
    {
      "border-hgGreen-800 ": primary,
      "border-hgBlue-700 hover:border-hgBlue-400": secondary,
      "border-gray-900 hover:bg-hgBlue-50": !primary && !secondary,
      "border-red-900 hover:border-red-800": danger,
      "bg-hgGreen-800 ": primary && !outline,
      "bg-hgBlue-700 hover:bg-hgBlue-500": secondary && !outline,
      "hover:bg-hgGreen-50 text-hgGreen-1100": primary && outline,
      "hover:text-hgBlue-900 hover:bg-hgBlue-100": secondary && outline,
      "bg-red-900 hover:bg-red-800": danger && !outline,
      "hover:bg-red-50": danger && outline,
      "text-hgCream-50": !outline && (primary || secondary || danger),
      rounded: rounded,
      "pointer-events-none opacity-50": disabled,
      "px-4": !(className || "").includes("px"),
      "py-2": !(className || "").includes("py"),
      "font-semibold": !(className || "").includes("font-normal"),
    },
    className
  );
  return (
    <button {...props} className={classes}>
      {!loading && children}
      {loading && (
        <FlexCentered col>
          <CgSpinner className="animate-spin" />
        </FlexCentered>
      )}
    </button>
  );
}

export default Button;
